import React, { FC, useState } from 'react';
import locale from 'antd/lib/date-picker/locale/ru_RU';

import { ArrowLeft2Outline, ArrowRight3Outline, Calendar1Outline } from 'ui/components/Icon';

import { RangePickerProps } from '../types';

// import HiddenLabels from './HiddenLabels';

import { StyledRangePicker, WrapperDatePicker, Styledlabel } from '../styled';

export const DateRangePicker: FC<RangePickerProps> = ({
  label,
  fullWidth,
  size,
  ...otherProps
}) => {
  const [id] = useState(Date.now().toString());

  return (
    <WrapperDatePicker>
      {label && <Styledlabel>{label}</Styledlabel>}
      {/* TODO - err undefined inputs */}
      {/* <HiddenLabels {...otherProps} id={id} /> */}
      <StyledRangePicker $fullWidth={fullWidth} $size={size} data-id={id} {...otherProps} />
    </WrapperDatePicker>
  );
};

DateRangePicker.defaultProps = {
  format: 'DD.MM.YYYY',
  separator: '-',
  suffixIcon: <Calendar1Outline />,
  nextIcon: <ArrowRight3Outline />,
  prevIcon: <ArrowLeft2Outline />,
  locale: locale,
  getPopupContainer: node => node || document.body,
};
